// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"b2085cc9","123":"44e77e4d","153":"8affa129","695":"756792ed"}[chunkId] + ".chunk.css";
};